export default {
  API_URL: process.env.REACT_APP_API_URL,
  ONESIGNAL_APP_KEY: process.env.REACT_APP_ONESIGNAL_APP_KEY,
  PUSHER_APP_KEY: process.env.REACT_APP_PUSHER_APP_KEY,
};
